import { defaultResumeData, type ResumeData } from "@reactive-resume/schema";
import type { Schema } from "zod";
import { z } from "zod";

import type { Parser } from "../interfaces/parser";

const pdfSchema = z.object({
  text: z.string(),
  metadata: z.object({}).optional(),
  aiParsed: z.boolean().optional(),
});

export type PdfData = z.infer<typeof pdfSchema>;

/**
 * @deprecated This client-side PDF parser is deprecated.
 * PDF parsing is now handled server-side via the /api/parser/pdf endpoint.
 * Use the parsePdfResume function from '@/client/src/services/parser/pdf' instead.
 */
export class PdfParser implements Parser<File, PdfData> {
  schema: Schema;

  constructor() {
    this.schema = pdfSchema;
  }

  readFile(file: File): Promise<File> {
    return Promise.resolve(file);
  }

  async validate(data: File): Promise<PdfData> {
    // PDF parsing is handled server-side via /api/parser/pdf endpoint
    return this.schema.parse({
      text: "PDF parsing is handled server-side. Use /api/parser/pdf endpoint.",
      metadata: {},
      aiParsed: false,
    });
  }

  async convert(_data: PdfData): Promise<ResumeData> {
    // PDF parsing is handled server-side via /api/parser/pdf endpoint
    return defaultResumeData;
  }
}
